export default __webpack_public_path__ + "static/thumbnails/no_favorites.png";